import React, { useMemo } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { SecurityDataEditorProps } from './SecurityDataEditor.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const SecurityDataEditor = (props: SecurityDataEditorProps) => {
  const { cell } = props;
  const { securityOptionsByEntity } = useCashFlowContext();

  // Find the entity cell in the same row
  const entityCell = useMemo(
    () =>
      Object.values(cell.sheet?.cells ?? {}).find(
        c => c.alias === 'entity' && c.rowNumber === cell.rowNumber
      ),
    [cell.sheet?.cells, cell.rowNumber]
  );

  // Get the entity value and extract the company ID from it
  const entityId = useMemo(() => {
    if (!entityCell?.value || typeof entityCell.value !== 'string') {
      return null;
    }
    if (entityCell.value.startsWith('company-')) {
      return parseInt(entityCell.value.replace('company-', ''), 10);
    }
    return null;
  }, [entityCell?.value]);

  // Get securities for the selected entity, or all securities if no entity selected
  const securityOptions = useMemo(() => {
    if (entityId && securityOptionsByEntity[entityId]) {
      return securityOptionsByEntity[entityId];
    }
    // If no entity selected or entity not found, show all securities
    return Object.values(securityOptionsByEntity).flat();
  }, [entityId, securityOptionsByEntity]);

  return <GridSelect menuPosition="fixed" usePortal options={securityOptions} {...props} />;
};

export default SecurityDataEditor;
